<template>
  <v-label
    class="form-label font-weight-medium text-uppercase text-secondary-30 opacity-100 d-block text-wrap pb-1"
  >
    <slot></slot>
  </v-label>
</template>
<style lang="css" scoped>
.form-label {
  font-size: 15px;
}
</style>
